import { Mail, Person, Smartphone } from '@mui/icons-material'
import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'

import 'react-phone-input-2/lib/style.css'
import { useContactFormMutation } from '../../helpers/SendEmailApi'
import { StyledSelect } from '../Price/style'

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CheckCircleIcon, PaperClipIcon } from '@heroicons/react/24/solid'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../utils/motion';

import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'


const CustomComponent = () => {
    return (
        <div className='h-full'>
            <div className='absolute top-0  left-0 right-0 z-[9999]'>
                <div className='flex justify-center'>
                    <CheckCircleIcon className='h-[55px] text-green-500 z-50 relative' />
                </div>
            </div>
            <div className='pt-[50px]'>
                <h1 className='text-center'>
                    Your response has been submitted successfully!
                </h1>
            </div>
        </div>
    )
}


const StatisticsForm = ({ vacancy, slugAdmin }) => {

    const data = ['Staff Augmentation', 'Dedicated Teams', 'Fixed Gigs', 'General Inquiry', 'Career Opportunity']

    const [name, setname] = useState('')
    const [phone, setphone] = useState('')
    const [email, setemail] = useState('')
    const [answer, setanswer] = useState('')
    const [mxg, setmxg] = useState('')
    const [fileName, setFileName] = useState('');
    const [form, setform] = useState('')
    const [loading, setloading] = useState(false)

    const [countryName, setCountryName] = useState('Pakistan');


    let placeholderdata = "Tells us what you need help with, the purpose of your project and the problem we're solving."
    let slug = 'Contact Form'

    if (vacancy) {
        placeholderdata = 'Why should we hire you?'
        slug = ['Vacancy Form', slugAdmin]
    }


    const [sendForm, res] = useContactFormMutation()

    const preventMinus = (e) => {
        if (e.code === 'Minus') {
            e.preventDefault();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        let formUrl = ''
        setloading(true)

        if (form) {

            const formData = new FormData();
            formData.append('file', form);
            formData.append('upload_preset', 'ojipiz6u');
            const res = await fetch(
                `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/auto/upload`,
                {
                    method: 'POST',
                    body: formData,
                }
            );
            const data = await res.json();
            formUrl = data.secure_url
        }

        sendForm({ name, phone, email, answer, mxg, formUrl, countryName,slug, vacancy })
    }


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setform(file)
        setFileName(file.name);
    };

    useEffect(() => {

        if (res.status === 'fulfilled') {
            setname('')
            setemail('')
            setanswer('')
            setmxg('')
            setphone('')
            setFileName('')
            setloading(false)

            toast(<CustomComponent />, {
                position: "top-center",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                toastClassName: "rounded-lg",
                className: 'text-[18px] md:w-[400px] h-full mx-4 mt-4 rounded-md relative z-50',
                style: { borderRadius: '15px' },
            });
        }

    }, [res])

    function handlePhoneChange(value, country) {
        setphone(value);

        const countryName = country.name;
        setCountryName(countryName);

    }

    return (

        <div className='relative'>

            <div className='relative'>
                <ToastContainer />
            </div>

            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}>
                <div>
                    <motion.div
                        variants={fadeIn('up', 'tween', 0.3, 1.0)}
                    >
                        <div className={`flex justify-center ${!vacancy && 'mt-5'}`}>
                            <div className='shadow-md rounded-xl w-full px-4 md:px-3 pt-3 pb-1 md:w-[80%] md:hover:scale-105 duration-700 bg-white border-t-4 border-b-4 border-red-500'>

                                <form className='md:px-2 py-3' onSubmit={(e) => handleSubmit(e)}>

                                    <div className='md:w-[95%] space-y-3 mx-auto'>

                                        {
                                            vacancy && (
                                                <h2 className='text-xl font-bold text-center text-red-500'>
                                                    Submit Your Application
                                                </h2>
                                            )
                                        }

                                        <TextField
                                            placeholder='Enter Your Name'
                                            id='Email'
                                            required
                                            value={name}
                                            fullWidth
                                            onChange={(e) => setname(e.target.value)}
                                            InputProps={{
                                                disableUnderline: true,
                                                style: {
                                                    fontSize: 15,
                                                },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Person sx={{ fontSize: '25px' }} />
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{

                                                '& .MuiInputBase-root': {
                                                    padding: '7px 10px',
                                                    borderRadius: '10px',
                                                    transition: 'all 0.4s ease-in-out',
                                                    backgroundColor: '#f2f7fb',
                                                },
                                                '& .Mui-focused': {
                                                    backgroundColor: 'black !important',
                                                    color: 'white',
                                                    '& .MuiSvgIcon-root': {
                                                        color: 'white'
                                                    },
                                                    '& ::placeholder': {
                                                        color: 'white',
                                                        opacity: '0.7'
                                                    }
                                                },

                                            }}
                                            variant="standard"
                                        />
                                        {!vacancy && (
                                            <PhoneInput
                                                country="pk"
                                                value={phone}
                                                onChange={handlePhoneChange}
                                                inputProps={{
                                                    disableUnderline: true,
                                                    style: {
                                                        fontSize: 15,
                                                        width: '100%',
                                                        borderColor: '#f2f7fb',
                                                        backgroundColor: '#f2f7fb',
                                                        height: '40px',
                                                        borderRadius: '10px',
                                                    },
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Smartphone sx={{ fontSize: "25px" }} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        )}

                                        <TextField
                                            placeholder='Enter Your Email'
                                            id='Email'
                                            required
                                            type={'email'}
                                            value={email}
                                            fullWidth
                                            onChange={(e) => setemail(e.target.value)}
                                            InputProps={{
                                                disableUnderline: true,
                                                style: {
                                                    fontSize: 15,
                                                },
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <Mail sx={{ fontSize: '25px' }} />
                                                    </InputAdornment>
                                                )
                                            }}
                                            sx={{

                                                '& .MuiInputBase-root': {
                                                    padding: '7px 10px',
                                                    borderRadius: '10px',
                                                    transition: 'all 0.4s ease-in-out',
                                                    backgroundColor: '#f2f7fb',
                                                },
                                                '& .Mui-focused': {
                                                    backgroundColor: 'black !important',
                                                    color: 'white',
                                                    '& .MuiSvgIcon-root': {
                                                        color: 'white'
                                                    },
                                                    '& ::placeholder': {
                                                        color: 'white',
                                                        opacity: '0.7'
                                                    }
                                                },

                                            }}
                                            variant="standard"
                                        />
                                        {!vacancy && (
                                            <div className='py-1'>
                                                <h1 className="text-xs font-bold">What are you seeking?</h1>
                                                <StyledSelect>
                                                    <FormControl focused={false} sx={{ width: '100%', borderRadius: '10px !important' }}>
                                                        <InputLabel id="demo-simple-select-label">Choose</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            required
                                                            name='Status'
                                                            value={answer}
                                                            label="Status"
                                                            onChange={(e) => setanswer(e.target.value)}
                                                            InputProps={{
                                                                disableUnderline: true,
                                                                style: {
                                                                    borderRadius: '20px'
                                                                }
                                                            }}
                                                            MenuProps={{ disableScrollLock: true }}
                                                        >
                                                            {data.map((value, i) => (
                                                                <MenuItem value={value} key={i}>{value}</MenuItem>
                                                            ))}

                                                        </Select>
                                                    </FormControl>
                                                </StyledSelect>
                                            </div>
                                        )}
                                        <TextField
                                            placeholder={placeholderdata}
                                            id='Email'
                                            required
                                            value={mxg}
                                            fullWidth
                                            multiline
                                            minRows={4}
                                            onChange={(e) => setmxg(e.target.value)}
                                            InputProps={{
                                                disableUnderline: true,
                                                style: {
                                                    fontSize: 15,
                                                },

                                            }}
                                            sx={{

                                                '& .MuiInputBase-root': {
                                                    padding: '10px 13px',
                                                    borderRadius: '10px',
                                                    transition: 'all 0.4s ease-in-out',
                                                    backgroundColor: '#f2f7fb',
                                                },
                                                '& .Mui-focused': {
                                                    backgroundColor: 'black !important',
                                                    color: 'white',
                                                    '& .MuiSvgIcon-root': {
                                                        color: 'white'
                                                    },
                                                    '& ::placeholder': {
                                                        color: 'white',
                                                        opacity: '0.7'
                                                    }
                                                },

                                            }}
                                            variant="standard"
                                        />

                                        <div>
                                            <input
                                                id="file-input"
                                                type="file"
                                                style={{ display: 'none' }}
                                                accept='.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .rtf, .zip, .rar, .tar, .gz'
                                                onChange={handleFileChange}
                                            />
                                            <label htmlFor="file-input" className='w-fit'>
                                                <div className='flex flex-wrap gap-1 items-center cursor-pointer'>
                                                    <div className='flex items-center gap-1 group'>
                                                        <PaperClipIcon className='h-3' />
                                                        <h6 className='text-[15px] text-[#757575] group-hover:text-black duration-700'>Attach  {!vacancy ? 'File' : 'CV'}</h6>
                                                    </div>
                                                    {fileName && (
                                                        <h6 className='text-[14px] text-[#757575]'>
                                                            ({fileName})
                                                        </h6>
                                                    )}
                                                </div>
                                            </label>
                                        </div>

                                        <FormGroup sx={{ marginTop: '5px !important' }}>
                                            <FormControlLabel control={<Checkbox required disableRipple
                                                sx={{ '& .MuiSvgIcon-root': { fontSize: 19 } }}
                                            />} sx={{
                                                '& .MuiTypography-root': {
                                                    fontSize: '14px',
                                                    color: '#757575'
                                                }
                                            }} label='I understand and agree to the terms & conditions.' />
                                        </FormGroup>

                                        <div className='sm:w-[90%] mx-auto'>
                                            <button
                                                type='submit'
                                                className={`w-full rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-semibold text-[14px] md:text-[17px] border-red-500`}>
                                                <span className={`absolute w-[350px] h-0 transition-all duration-700 origin-center rotate-45 -translate-x-20 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease bg-red-500`}></span>
                                                <span className={`relative text-red-500 transition duration-700 ease group-hover:text-white`}>
                                                    {loading ? (
                                                        <svg aria-hidden="true" className="inline w-[25px] h-[25px] text-gray-200 animate-spin dark:text-gray-600 fill-red-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                                        </svg>
                                                    ) : 'Submit'}
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </div >
    )
}

export default StatisticsForm